import Footer from 'components/Footer';
import { HasRoles } from '@voxityai/auth/components';
import { auth } from 'data/firestore/firebase';
import AgentPhoneNumbers from './AgentPhoneNumbers';
import OutboundCallPhoneNumbers from './OutboundCallPhoneNumbers';
import SipDomains from './SipDomains';
import { PageContainer, Container } from './styled';

const PhoneNumbersPage = () => (
    <PageContainer>
        <Container>
            <HasRoles auth={auth} allowedRoles={['admin']}>
                <AgentPhoneNumbers />
            </HasRoles>
            <HasRoles auth={auth} allowedRoles={['admin']}>
                <SipDomains />
            </HasRoles>
            <OutboundCallPhoneNumbers />
        </Container>
        <Footer />
    </PageContainer>
);

export default PhoneNumbersPage;
